import {merge} from "lodash";

export class Customisation {
    //FIXME : en doublon avec gme-server-app\src\modules\clients\constants.ts
    //FIXME : en doublon avec gme-admin-client\src\lib\models\customisation.ts
    public title = "";

    // config par défaut de la page login
    public signinPage: any = {
        logo: {fileId: "geoptis_pour_fond_blanc.png", width: "400px"},
        subLogo: {fileId: null, width: null},
        poweredBy: {fileId: null, width: null},
        text: null,
        button: {color: null, background: null},
        background: {overlay: null, image: null}
    };

    public colors = {
        primary: "#003da5",
        action: "#002657",
        actionLabel: "#fff",
        commands: {
            default: "#1D345B",
            hover: "#fff",
            active: "#fff",
        }
    };

    public navbarLogo = {
        fileId: "geoptis_pour_fond_colore.png",
        width: "200px"
    }

    public engines:any = {};

    static fromPayload(payload: any): Customisation {
        const customisation = new Customisation();
        merge(customisation, payload);
        return customisation;
    }

}
